import React from 'react';

import { StyledGrid, StyledGridContainer } from './Grid.styles';
import { GridComponentProps } from './Grid.types';

const Grid = (props: GridComponentProps): JSX.Element => {
  return props.container && !props.fluid ? (
    <StyledGridContainer {...props}>{props.children}</StyledGridContainer>
  ) : (
    <StyledGrid {...props}>{props.children}</StyledGrid>
  );
};

export default Grid;
